<div class="bg-red py-72 px-16">
  <div class="">
    <form class="max-w-640 text-center mx-auto">
      <h2
        class="h3 text-white"
      >
        Join Our Mailing List!
      </h2>
      <p class="text-white p py-24">
        Receive event updates and opportunities from Iowa Code Camp. We promise to never spam, sell, or otherwise abuse your email.
      </p>
      <div class="w-140 mx-auto">
        <a
          class="block border-2 text-center rounded-8 px-16 py-8 rounded transition w-full bg-transparent border-white"
          [href]="signupLink"
          target="_blank"
        >
          <span class="strong text-white">Join Us</span>
        </a>
      </div>
    </form>
  </div>
<div>
